import { render, staticRenderFns } from "./StepsInfoPreOffice.vue?vue&type=template&id=6efc8833&"
import script from "./StepsInfoPreOffice.vue?vue&type=script&lang=js&"
export * from "./StepsInfoPreOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6efc8833')) {
      api.createRecord('6efc8833', component.options)
    } else {
      api.reload('6efc8833', component.options)
    }
    module.hot.accept("./StepsInfoPreOffice.vue?vue&type=template&id=6efc8833&", function () {
      api.rerender('6efc8833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/StepsInfoPreOffice.vue"
export default component.exports